module.exports = __webpack_public_path__ + "static/profile-6405b71c7c2092aab8407b83bca4d3e9.jpeg";